/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
/* eslint max-lines: ["error", 650] */
import { loadLayoutData, loadModulesData } from '@tcp/core/src/reduxStore/actions';
import { call, put, takeLatest, select, race, fork, delay, join } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import { isClient } from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getUnbxdXappConfigs } from '@tcp/core/src/components/features/browse/ProductListing/container/ProductListing.saga';
import { getModuleX } from '@tcp/core/src/services/abstractors/common/moduleX/index';
import { getAlternateBrandName } from '@tcp/core/src/components/features/browse/SearchDetail/container/SearchDetail.selectors';
import {
  getIsPDPCalledViaRecommendation,
  newBreadcrumbs,
} from '@tcp/core/src/components/features/browse/ProductDetail/container/ProductDetail.selectors';
import processHelperUtil, {
  updateColorFitsSizesMapWithSFCCInventoryData,
  updateRawDataWithSFCCInventoryData,
  isPureVMPProduct,
} from '@tcp/core/src/services/abstractors/productListing/ProductDetail.util';
import MAX_PRODUCT_PART_NUMBER_ALLOWED from '@tcp/core/src/constants/numeric.constants';
import bootstrapAbstractor from '@tcp/core/src/services/abstractors/bootstrap';
import {
  getStringAfterSplit,
  getMultipackCount,
  filterMultiPack,
  isServer,
  getAPIConfig,
} from '../../../../../utils/utils';
import PRODUCTLISTING_CONSTANTS from './ProductDetail.constants';
import {
  getIsPdpServiceEnabled,
  getABTestPdpService,
  getIsPDPInventoryCheckEnabled,
  getDynamicContentPDP,
  getIsColorConsolidationEnabled,
  getIsOOSColorSwatchRemoved,
  getIsOrderableFilterEnable,
  getIsExtendedInventoryPromoMessagingEnabled,
  getShowStoreSpecialsV2,
  getStoreSpecialsPREnabled,
  getSfccSocialProofingEnabled,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getDefaultFavStore } from '../../../account/User/container/User.selectors';
import {
  setProductDetails,
  setUpdatedProductDetails,
  setPDPLoadingState,
  setProductDetailsDynamicData,
  setUpdatedProductDetailsDynamicData,
  setUpdatedProductDetailsMultipackVmpScenario,
  setPageUrl,
  setPDPDisplayPriceState,
  setMultiPackDetails,
  singlePageLoadAction,
  setDisableSelectedTab,
  setReviewData,
  setSizeGuideModuleX,
  setAdditionalPromoModuleX,
  dynamicContentLoader,
  setIsDeptClicked,
  setShippingAndReturnsModuleX,
  setSimilarProducts,
  resetSimilarProducts,
} from './ProductDetail.actions';
import getProductInfoById, {
  layoutResolver,
  getProductBVReviewStats,
  sfccInventoryApi,
  getSimilarProductInfo,
} from '../../../../../services/abstractors/productListing/productDetail';
import { getUserSelectionApi } from '../../../../../services/abstractors/productListing/userbrowsehistory';
import { getDefaultWishList } from '../../Favorites/container/Favorites.saga';
import { setSlpLoadingState } from '../../SearchDetail/container/SearchDetail.actions';
import { loadNavigationData } from '../../../content/Navigation/container/Navigation.actions';

const checkSSR = () => typeof window !== 'undefined';
const windowCheck = () => typeof window !== 'undefined';

export const isVmpOrPvmpProduct = (item) => {
  return item?.isVMPEnabled === 'true';
};

// eslint-disable-next-line max-params
function* backgroundTask(
  productColorId,
  state,
  isBotDevice,
  originalURL,
  xappURLConfig,
  isPdpServiceEnabled,
  enablePDPServiceABTest,
  config,
  otherBrand,
  viaModuleName,
  brand,
  storeId,
  isFromBarCode,
  newFitsEnabled,
  generalProductId
) {
  try {
    const alternateBrand = yield select(getAlternateBrandName);
    const isPDPCalledViaRecommendationModule = yield select(getIsPDPCalledViaRecommendation);
    const isColorConsolidationEnabled = yield select(getIsColorConsolidationEnabled);
    const isUNBXDOrderableFlag = yield select(getIsOrderableFilterEnable);
    const viewType = 'PDP';
    return yield call(
      getProductInfoById,
      xappURLConfig,
      productColorId,
      state,
      brand,
      undefined,
      isBotDevice,
      originalURL,
      undefined,
      undefined,
      newFitsEnabled ? generalProductId : undefined,
      undefined,
      isPdpServiceEnabled,
      enablePDPServiceABTest,
      config,
      !isPDPCalledViaRecommendationModule && (otherBrand || alternateBrand),
      viaModuleName,
      '',
      viewType,
      isColorConsolidationEnabled,
      storeId,
      isUNBXDOrderableFlag,
      undefined,
      isFromBarCode,
      newFitsEnabled
    );
  } catch (e) {
    throw new Error();
  }
}

function* callSFCCInventoryAPI({ productDetail, newProductDetail, defaultStoreId }) {
  let INITIAL_VALUE = 0;
  let taskData = [];
  let MAX_VALUE = MAX_PRODUCT_PART_NUMBER_ALLOWED;
  const allProducts = isPureVMPProduct(productDetail?.product?.TCPStyleType)
    ? []
    : productDetail?.product?.allProductPartNos;
  if (newProductDetail?.product?.getMultiPackAllColor) {
    newProductDetail?.product?.getMultiPackAllColor.forEach((item) => {
      allProducts.push(item?.prodpartno || []);
    });
  }
  let allProductPartNosLength = allProducts?.length;
  // To make multiple calls when allProductPartNosLength is greater that maximum allowed productPartNo value
  while (allProductPartNosLength > 0) {
    const sfccTaskData = yield fork(
      sfccInventoryApi,
      allProducts?.slice(INITIAL_VALUE, MAX_VALUE),
      defaultStoreId
    );
    if (sfccTaskData) {
      taskData = [...taskData, sfccTaskData];
    }
    // Set the INITIAL_VALUE to max value, add maximum allowed prodPartNo to MAX_VALUE, and reduce the allProductParNos length by maximum allowed prodPartNo value for next iteration
    INITIAL_VALUE = MAX_VALUE;
    MAX_VALUE += MAX_PRODUCT_PART_NUMBER_ALLOWED;
    allProductPartNosLength -= MAX_PRODUCT_PART_NUMBER_ALLOWED;
  }
  return taskData;
}

// eslint-disable-next-line
export function* fetchProductDetail({ payload }) {
  const {
    productColorId,
    isMultiPack,
    generalProductId,
    escapeEmptyProduct,
    resolve,
    isBotDevice,
    url,
    originalURL = '',
    getDetailonClick,
    apiConfig: config,
    otherBrand,
    viaModuleName,
    isTakeDownClick,
    takeDownCategory,
    brand,
    bootstrapPayload,
    storeId,
    isFromBarCode,
    newFitsEnabled,
  } = payload;

  yield put(
    setSlpLoadingState({
      alternateBrandName: '',
    })
  );
  const xappURLConfig = yield call(getUnbxdXappConfigs);
  const alternateBrand = yield select(getAlternateBrandName);
  const isDynamicContentPDPEnabled = yield select(getDynamicContentPDP);
  const isPDPCalledViaRecommendationModule = yield select(getIsPDPCalledViaRecommendation);
  try {
    const pageName = 'pdp';
    let oldProductDetail;
    let newProductDetail;
    let multipackCall;
    let newPartId;
    let finalPartId;
    let partId;
    if (!isDynamicContentPDPEnabled) {
      yield put(loadLayoutData({}, pageName));
    }

    if (!escapeEmptyProduct && !getDetailonClick) {
      yield put(setProductDetails({ product: {} }));
    }
    const state = yield select();
    yield put(setPDPLoadingState({ isLoading: true }));
    const hidePriceDisplay = false;
    yield put(setPDPDisplayPriceState({ hidePriceDisplay }));
    if (isServer()) {
      const { deviceType, originalUrl } = bootstrapPayload;
      const processedCacheData = {};

      const result = yield call(
        bootstrapAbstractor,
        pageName,
        ['navigation'],
        processedCacheData,
        state,
        originalUrl,
        deviceType
      );
      yield put(loadNavigationData(result.navigation));
    }
    const isPdpServiceEnabled = yield select(getIsPdpServiceEnabled);
    const enablePDPServiceABTest = yield select(getABTestPdpService);
    const isUNBXDOrderableFlag = yield select(getIsOrderableFilterEnable);
    const isSSRSingles = !hidePriceDisplay && !isMultiPack;
    if (isSSRSingles) {
      const apiOutput = yield race({
        productDetailInfo: backgroundTask(
          productColorId,
          state,
          isBotDevice,
          originalURL,
          xappURLConfig,
          isPdpServiceEnabled,
          enablePDPServiceABTest,
          config,
          !isPDPCalledViaRecommendationModule && (otherBrand || alternateBrand),
          viaModuleName,
          brand,
          storeId,
          isFromBarCode,
          newFitsEnabled,
          generalProductId
        ),
        timeout: delay(30000),
      });
      if (apiOutput && apiOutput.productDetailInfo) {
        oldProductDetail = apiOutput.productDetailInfo;
      } else {
        yield put(setPDPDisplayPriceState({ hidePriceDisplay: false }));
        logger.error({
          error: 'Error fetching unbxd response on singles PDP server',
          extraData: {
            component: 'ProductDetail Saga - fetchProductDetail - apiOutput',
            payloadReceived: {
              colorId: productColorId,
              botDevice: isBotDevice,
              isMultiPack,
              hidePriceDisplay,
            },
          },
        });
      }
    } else if (isMultiPack) {
      multipackCall = yield call(
        getProductInfoById,
        xappURLConfig,
        productColorId,
        state,
        brand,
        undefined,
        isBotDevice,
        originalURL,
        false,
        undefined,
        generalProductId,
        true,
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        config,
        !isPDPCalledViaRecommendationModule && (otherBrand || alternateBrand),
        viaModuleName,
        undefined,
        undefined,
        undefined,
        storeId,
        isUNBXDOrderableFlag
      );
      oldProductDetail = multipackCall;
    } else {
      oldProductDetail = yield call(
        getProductInfoById,
        xappURLConfig,
        productColorId,
        state,
        brand,
        undefined,
        isBotDevice,
        originalURL,
        false,
        undefined,
        undefined,
        false,
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        config,
        !isPDPCalledViaRecommendationModule && (otherBrand || alternateBrand),
        viaModuleName,
        undefined,
        undefined,
        undefined,
        storeId,
        isUNBXDOrderableFlag
      );
    }
    const { primaryCategoryId } = oldProductDetail || {};
    let newBreadCrumbsArray = yield select(newBreadcrumbs(primaryCategoryId?.value));
    newBreadCrumbsArray = processHelperUtil.processBreadcrumbs(newBreadCrumbsArray);
    if (oldProductDetail && oldProductDetail.product && oldProductDetail.product.multiPackUSStore) {
      let multiplePartId = '';
      partId = oldProductDetail.product.tcpMultiPackReferenceUSStore.join(',').split(',');
      const updatedPartId = new Set(partId);
      const findUpdatedPartId = [...updatedPartId];
      for (let id = 0; id < findUpdatedPartId.length; id += 1) {
        if (findUpdatedPartId[id].includes(',')) {
          const arrayOfPartNum = getStringAfterSplit(findUpdatedPartId[id], ',');
          for (let num = 0; num < arrayOfPartNum.length; num += 1) {
            multiplePartId = multiplePartId.concat(
              getStringAfterSplit(arrayOfPartNum[num], '#')[0]
            );
            if (num !== arrayOfPartNum.length - 1) {
              multiplePartId = multiplePartId.concat(',');
            }
          }
        } else {
          newPartId = findUpdatedPartId[id]
            ? [getStringAfterSplit(findUpdatedPartId[id], '#')[0]]
            : '';
          multiplePartId += newPartId ? `${newPartId},` : '';
        }
      }
      finalPartId = multiplePartId;
      newProductDetail = yield call(
        getProductInfoById,
        xappURLConfig,
        finalPartId,
        state,
        brand,
        undefined,
        isBotDevice,
        originalURL,
        true,
        partId,
        undefined,
        undefined,
        isPdpServiceEnabled,
        enablePDPServiceABTest,
        config,
        !isPDPCalledViaRecommendationModule && (otherBrand || alternateBrand),
        viaModuleName,
        undefined,
        undefined,
        undefined,
        storeId,
        isUNBXDOrderableFlag
      );
    }
    const { newCategoryIdList, categoryIdList, getMultiPackAllColor, ...productDetail } =
      oldProductDetail || {};
    const newMultiPackCount =
      productDetail &&
      productDetail.product &&
      productDetail.product.multiPackUSStore &&
      productDetail.product.tcpMultiPackReferenceUSStore &&
      productDetail.product.tcpMultiPackReferenceUSStore[0]?.split(',');

    const multiPackCount = newMultiPackCount ? getMultipackCount(newMultiPackCount) : 0;
    const { product: { category } = {} } = productDetail;
    if (productDetail && productDetail.product) {
      if (alternateBrand) productDetail.product.alternateBrand = alternateBrand;
      productDetail.product.isSSRData = !isClient();
    } else if (!isSSRSingles) {
      logger.error({
        error: 'Error fetching unbxd response on PDP',
        extraData: {
          component: 'ProductDetail Saga - fetchProductDetail',
          payloadReceived: {
            colorId: productColorId,
            botDevice: isBotDevice,
            isMultiPack,
            hidePriceDisplay,
          },
        },
      });
    }
    if (!getDetailonClick) {
      if (productDetail?.product?.colorConsolidationTCPmapNewStyleId?.length > 0) {
        yield put(
          singlePageLoadAction({
            singlepageload: true,
            availableTCPMultipackProductMapping:
              productDetail.product && productDetail.product.TCPMultipackProductMapping,
            availableTCPmapNewStyleId:
              productDetail.product && productDetail.product.TCPmapNewStyleId,
            availableColorConsolidationTCPmapNewStyleId:
              productDetail.product && productDetail.product.colorConsolidationTCPmapNewStyleId,
            initialSelectedQty: Number(
              productDetail.product && productDetail.product.TCPStyleQTY
            ).toString(),
          })
        );
      } else {
        yield put(
          singlePageLoadAction({
            singlepageload: true,
            availableTCPMultipackProductMapping:
              productDetail.product && productDetail.product.TCPMultipackProductMapping,
            availableTCPmapNewStyleId:
              productDetail.product && productDetail.product.TCPmapNewStyleId,
            initialSelectedQty: Number(
              productDetail.product && productDetail.product.TCPStyleQTY
            ).toString(),
          })
        );
      }
    }
    const CheckifProductAvailable =
      productDetail &&
      productDetail.product &&
      productDetail.product.colorFitsSizesMap.length &&
      productDetail.product.unbxdProdId;

    const alternateStyles = processHelperUtil.getAlternateStyleBasedOnSelectedColor(
      productDetail?.product?.allProductId,
      productColorId
    );
    const isPDPInventoryCheckEnabled = yield select(getIsPDPInventoryCheckEnabled);
    const defaultStore = yield select(getDefaultFavStore);
    const defaultStoreId = defaultStore?.basicInfo?.id;
    let sfccCallTaskObject;
    if (isPDPInventoryCheckEnabled && CheckifProductAvailable) {
      sfccCallTaskObject = yield fork(callSFCCInventoryAPI, {
        productDetail,
        newProductDetail,
        defaultStoreId,
      });
    }
    if (CheckifProductAvailable) {
      getUserSelectionApi();

      if (isTakeDownClick) {
        yield put(
          setProductDetails({
            alternateStyles,
            ...productDetail,
            product: {
              ...productDetail.product,
              takeDownCategory,
              isTakeDownProduct: true,
            },
            breadCrumbs: newBreadCrumbsArray,
          })
        );
      } else {
        yield put(
          setProductDetails({ ...productDetail, breadCrumbs: newBreadCrumbsArray, alternateStyles })
        );
      }
    }
    if (newProductDetail) {
      const getFilterData = newProductDetail.product.categoryIdList;
      const getmultipackProduct = getFilterData && filterMultiPack(getFilterData);
      yield put(
        setMultiPackDetails({
          newPartNumber: getmultipackProduct,
          multiPackCount,
          getMultiPackAllColor: productDetail.product.getMultiPackAllColor,
          getNewMultiPackAllColor: newProductDetail.product.getMultiPackAllColor,
          partIdDetail: newProductDetail.product.partIdDetails,
        })
      );
    } else {
      yield put(
        setMultiPackDetails({
          newPartNumber: null,
          multiPackCount: null,
          getMultiPackAllColor: null,
        })
      );
    }

    yield put(setPDPLoadingState({ isLoading: false }));
    yield put(setIsDeptClicked(false));

    yield call(getDefaultWishList);

    if (category) {
      let apiConfig = config;
      if (
        !isServer() &&
        (typeof apiConfig === 'undefined' || Object.keys(apiConfig).indexOf('brandIdCMS') < 0)
      ) {
        apiConfig = getAPIConfig();
      }
      const { layout, modules } = yield call(layoutResolver, { category, pageName, apiConfig });
      if (isDynamicContentPDPEnabled || checkSSR()) {
        yield put(loadLayoutData(layout, pageName));
        yield put(loadModulesData(modules));
      }
    }
    yield put(dynamicContentLoader(false));

    if (!CheckifProductAvailable) {
      yield put(setDisableSelectedTab({ disabledTab: true }));
    } else if (CheckifProductAvailable && isTakeDownClick) {
      yield put(
        setProductDetails({
          alternateStyles,
          ...productDetail,
          product: {
            ...productDetail.product,
            takeDownCategory,
            isTakeDownProduct: true,
            breadCrumbs: newBreadCrumbsArray,
          },
        })
      );
    } else {
      yield put(
        setProductDetails({ ...productDetail, breadCrumbs: newBreadCrumbsArray, alternateStyles })
      );
    }
    if (windowCheck() && CheckifProductAvailable) {
      yield put(
        setProductDetailsDynamicData({ ...productDetail, breadCrumbs: newBreadCrumbsArray })
      );
    }
    if (url) {
      yield put(setPageUrl(url));
    }

    const isExtendedInventoryPromoMessagingEnabled = yield select(
      getIsExtendedInventoryPromoMessagingEnabled
    );
    const storeSpecialV2Enabled = yield select(getShowStoreSpecialsV2);
    const storeSpecialPREnabled = yield select(getStoreSpecialsPREnabled);

    if (isPDPInventoryCheckEnabled && CheckifProductAvailable) {
      let data = [];
      const taskData = yield join(sfccCallTaskObject);
      // Loop through the forked requests and join to get the final api response
      for (let i = 0; i < taskData.length; i += 1) {
        const apiResponse = yield join(taskData[i]);
        if (apiResponse) {
          data = [...data, ...apiResponse];
        }
      }

      if (data.length > 0) {
        const isGiftCardProduct = productDetail.product.isGiftCard;
        const isAccessoryProduct = !isEmpty(
          productDetail.product.accessoriesData?.accessoriesProductID
        );
        const sfccSocialProofingOn = yield select(getSfccSocialProofingEnabled);
        const shouldUpdateInventoryAttributesCheck =
          isExtendedInventoryPromoMessagingEnabled && !isGiftCardProduct && !isAccessoryProduct;
        let updatedColorFitsSizesMap = updateColorFitsSizesMapWithSFCCInventoryData({
          colorFitsSizesMap: productDetail.product.colorFitsSizesMap,
          data,
          shouldUpdateInventoryAttributesCheck,
          defaultStoreId,
          storeSpecialV2Enabled,
          storeSpecialPREnabled,
          sfccSocialProofingOn,
        });
        const isOOSColorSwatchRemoved = yield select(getIsOOSColorSwatchRemoved);
        if (isOOSColorSwatchRemoved) {
          const filteredColorFitsSizesMap = updatedColorFitsSizesMap.filter((item) =>
            isVmpOrPvmpProduct(item) || item.colorProductId === productColorId
              ? true
              : item.maxAvailable !== 0
          );

          if (filteredColorFitsSizesMap?.length > 0) {
            updatedColorFitsSizesMap = filteredColorFitsSizesMap;
          } else {
            updatedColorFitsSizesMap = [updatedColorFitsSizesMap[0]];
          }
        }
        const updatedAllProductId = updateRawDataWithSFCCInventoryData(
          productDetail.product.allProductId,
          data
        );
        const updatedMultiPackAllColor = updateRawDataWithSFCCInventoryData(
          productDetail.product.getMultiPackAllColor,
          data
        );
        const updatedNewMultiPackAllColor = updateRawDataWithSFCCInventoryData(
          newProductDetail?.product?.getMultiPackAllColor,
          data,
          false,
          false
        );
        const updatedCategoryIdList = updateRawDataWithSFCCInventoryData(
          productDetail.product.categoryIdList,
          data,
          false,
          true
        );
        const updatedNewCategoryIdList = updateRawDataWithSFCCInventoryData(
          productDetail.product.newCategoryIdList,
          data,
          true,
          false
        );

        let updatedHighOfferPrice = productDetail.product.highOfferPrice;
        if (shouldUpdateInventoryAttributesCheck) {
          const currentProductInventoryData = data.find(
            (item) => item.id === productDetail.product.productId
          );

          if (currentProductInventoryData?.price_max) {
            updatedHighOfferPrice = currentProductInventoryData.price_max;
          }
        }

        yield put(
          setUpdatedProductDetails({
            colorFitsSizesMap: updatedColorFitsSizesMap,
            allProductId: updatedAllProductId,
            getMultiPackAllColor: updatedMultiPackAllColor,
            categoryIdList: updatedCategoryIdList,
            newCategoryIdList: updatedNewCategoryIdList,
            highOfferPrice: updatedHighOfferPrice,
          })
        );

        if (newProductDetail) {
          yield put(
            setUpdatedProductDetailsMultipackVmpScenario({
              getNewMultiPackAllColor: updatedNewMultiPackAllColor,
              getMultiPackAllColor: updatedMultiPackAllColor,
            })
          );
        }
        if (windowCheck()) {
          yield put(
            setUpdatedProductDetailsDynamicData({
              colorFitsSizesMap: updatedColorFitsSizesMap,
              allProductId: updatedAllProductId,
              getMultiPackAllColor: updatedMultiPackAllColor,
              categoryIdList: updatedCategoryIdList,
              newCategoryIdList: updatedNewCategoryIdList,
            })
          );
        }
      }
    }
    if (resolve) {
      resolve();
    }
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'ProductDetail Saga - fetchProductDetail',
        payloadReceived: {
          colorId: productColorId,
          botDevice: isBotDevice,
          isMultiPack,
        },
      },
    });
    yield put(setPDPLoadingState({ isLoading: false }));
    yield put(setIsDeptClicked(false));

    yield put(setPDPDisplayPriceState({ hidePriceDisplay: false }));
    if (resolve) {
      resolve();
    }
  }
}
export function* fetchSimilarProductsSaga({ payload }) {
  try {
    const { productId, brand, gender } = payload;
    const apiConfig = getAPIConfig();
    const { genAiSimilarProductsUrl: apiUrl } = apiConfig;
    const alternateBrand = yield select(getAlternateBrandName);
    const xappURLConfig = yield call(getUnbxdXappConfigs);
    let url = `${apiUrl}?product_id=${productId}&brand=${brand}`;
    if (gender) {
      url += `&gender=${gender}`;
    }

    const response = yield call(fetch, url);
    const data = yield call([response, 'json']);
    if (data?.similar_products.length === 0) {
      yield put(resetSimilarProducts());
      return;
    }

    if (!response.ok) {
      logger.error({
        error: `Failed to fetch similar products`,
      });
    }
    const similarProductIds = data?.similar_products.map(([id]) => id).join(',');
    const fieldsList = [
      'product_name',
      'productid',
      'min_offer_price',
      'min_list_price',
      'max_offer_price',
      'max_list_price',
      'unbxd_imageUrl',
      'prodpartno',
      'list_of_attributes',
      'genderAgeGroup',
      'low_offer_price',
      'high_offer_price',
      'low_list_price',
      'high_list_price',
      'primaryBrand',
      'TCPCustomListPrice',
      'TCPCustomSalePrice',
      'productimage',
      'TCPPrimaryBrandUSStore',
      'TCPPrimaryBrandCanadaStore',
      'seo_token',
      'TCPPrimaryCategoryCanadaStore',
      'TCPPrimaryCategoryUSStore',
      'favoritedcount',
      'TCPBazaarVoiceRating',
      'TCPProductIndCanadaStore',
      'TCPProductIndUSStore',
      'TCPColor',
      'TCPBazaarVoiceReviewCount',
      'TCPMerchantTagUSStore',
      'TCPMerchantTagCanadaStore',
      'TCPStyleTypeUS',
      'TCPStyleTypeCA',
      'TCPStyleQTYUS',
      'TCPStyleQTYCA',
      'tcp_promo_price',
      'tcp_promotion_id',
    ];

    const isUNBXDOrderableFlag = yield select(getIsOrderableFilterEnable);
    const state = yield select();

    const similarProducts = yield call(getSimilarProductInfo, {
      productIds: similarProductIds,
      fields: fieldsList.join(','),
      brand,
      alternateBrand,
      xappURLConfig,
      originalURL: window.location.href,
      apiConfig,
      isUNBXDOrderableFlag,
      state,
    });
    yield put(setSimilarProducts(similarProducts));
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'ProductDetail Saga - fetchSimilarProductsSaga',
        payloadReceived: payload,
      },
    });
  }
}

function* fetchReviewsData({ payload }) {
  const BazaarVoice = yield call(getProductBVReviewStats, payload);
  yield put(setReviewData(BazaarVoice));
}

export function* fetchSizeGuideModuleX({ payload }) {
  const { contentId, brand } = payload;
  try {
    const result = yield call(getModuleX, contentId);
    yield put(setSizeGuideModuleX({ brand, content: result }));
  } catch (err) {
    yield null;
  }
}

export function* fetchAdditionalPromoModuleX({ payload }) {
  const { contentId } = payload;
  try {
    const result = yield call(getModuleX, contentId);
    yield put(setAdditionalPromoModuleX({ content: result }));
  } catch (err) {
    yield null;
  }
}

export function* fetchShippingAndRetaurnsModule({ payload }) {
  const { contentId } = payload;
  try {
    const result = yield call(getModuleX, contentId);
    yield put(setShippingAndReturnsModuleX({ content: result }));
  } catch (err) {
    yield null;
  }
}

function* ProductDetailSaga() {
  yield takeLatest(PRODUCTLISTING_CONSTANTS.FETCH_PRODUCT_DETAILS, fetchProductDetail);
  yield takeLatest(PRODUCTLISTING_CONSTANTS.GET_REVIEW_DATA, fetchReviewsData);
  yield takeLatest(PRODUCTLISTING_CONSTANTS.FETCH_SIZECHART_MODULEX_CONTENT, fetchSizeGuideModuleX);
  yield takeLatest(
    PRODUCTLISTING_CONSTANTS.FETCH_ADDITIONAL_PROMO_MODULEX_CONTENT,
    fetchAdditionalPromoModuleX
  );
  yield takeLatest(
    PRODUCTLISTING_CONSTANTS.FETCH_SHIPPING_AND_RETURNS_MODULEX_CONTENT,
    fetchShippingAndRetaurnsModule
  );

  yield takeLatest(PRODUCTLISTING_CONSTANTS.FETCH_SIMILAR_PRODUCTS, fetchSimilarProductsSaga);
}

export default ProductDetailSaga;
